<template>
  <div class="apl-bg">
    <div class="apl-content">
      <h2 class="big-title">Ethernet-APL生态领航计划</h2>
      <p class="des">我们将竭诚为您提供专业的合作咨询服务</p>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="" label-width="0">
          <h3 class="apl-title">申请人信息：</h3>
        </el-form-item>
        <el-form-item label="联系人：" prop="applicantName">
          <el-input
            v-model="ruleForm.applicantName"
            placeholder="请输入"
            maxlength="100"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="applicantContact">
          <el-input
            v-model="ruleForm.applicantContact"
            placeholder="请输入"
            maxlength="100"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="职务：" prop="applicantPost">
          <el-input
            v-model="ruleForm.applicantPost"
            placeholder="请输入"
            maxlength="100"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱：" prop="applicantEmail">
          <el-input
            v-model="ruleForm.applicantEmail"
            placeholder="请输入"
            maxlength="100"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="" label-width="0">
          <h3 class="apl-title">申请单位信息：</h3>
        </el-form-item>
        <el-form-item label="单位名称：" prop="companyName">
          <el-input
            v-model="ruleForm.companyName"
            placeholder="请输入"
            maxlength="100"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="单位地址：" prop="companyAddress">
          <el-input
            v-model="ruleForm.companyAddress"
            placeholder="请输入"
            maxlength="100"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="法定代表人/负责人姓名："
          prop="companyLegalRepresentative"
          label-width="190px"
        >
          <el-input
            v-model="ruleForm.companyLegalRepresentative"
            placeholder="请输入"
            maxlength="100"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label-width="190px"
          label="营业执照/法人证书编号："
          prop="companyLicenseNumber"
        >
          <el-input
            v-model="ruleForm.companyLicenseNumber"
            placeholder="请输入"
            maxlength="100"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="" label-width="0">
          <h3 class="apl-title">申请加入的理由：</h3>
        </el-form-item>
        <el-form-item label="" label-width="0" prop="applyReason">
          <el-input
            type="textarea"
            v-model="ruleForm.applyReason"
            placeholder="请输入"
            maxlength="1000"
            show-word-limit
            :autosize="{ minRows: 3, maxRows: 10 }"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="上传附件：" prop="attachmentList">
          <el-upload
            class="upload-demo"
            :action="action"
            :on-success="onSuccess"
            :headers="headers"
            multiple
            :limit="5"
            :on-exceed="handleExceed"
          >
            <div class="upload-btn">
              <img src="./images/upload.png" />
              <span>点击上传</span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="" label-width="0">
          <div class="list">
            <div
              class="item"
              v-for="(item, index) in ruleForm.attachmentList"
              :key="index"
            >
              <img src="./images/link.png" alt="" />
              <span class="name">{{ item.name }}</span>
              <img
                @click="() => handleRemove(index)"
                class="close"
                src="./images/close.png"
                alt=""
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label-width="0">
          <el-button
            type="primary"
            class="sub-btn"
            :loading="loading"
            @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <div class="more-tip">更多信息请咨询apl@supcon.com</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import validate from '@/utils/validate'
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      action: window.SITE_CONFIG['apiURL'] + '/openapi/v1/alioss/upload',
      headers: {
        Authorization: 'Bearer ' + getAccessToken() || ''
      },
      loading: false,
      ruleForm: {
        applicantName: '',
        applicantContact: '',
        applicantPost: '',
        applicantEmail: '',
        companyName: '',
        companyAddress: '',
        companyLegalRepresentative: '',
        companyLicenseNumber: '',
        applyReason: '',
        attachmentList: []
      },
      rules: {
        applicantName: [
          { required: true, message: '请输入联系人', trigger: 'change' }
        ],
        applicantContact: [
          { required: true, message: '请输入联系电话', trigger: 'change' },
          {
            validator: validate.validatePhoneTwo,
            trigger: 'change'
          }
        ],
        applicantPost: [
          {
            required: false,
            message: '请输入职务',
            trigger: 'change'
          }
        ],
        applicantEmail: [
          {
            required: false,
            type: 'email',
            message: '请输入电子邮箱',
            trigger: 'change'
          }
        ],
        companyName: [
          {
            required: true,
            message: '请输入单位名称',
            trigger: 'change'
          }
        ],
        companyAddress: [
          { required: true, message: '请输入单位地址', trigger: 'change' }
        ],
        companyLegalRepresentative: [
          {
            required: false,
            message: '请输入法定代表人/负责人姓名',
            trigger: 'change'
          }
        ],
        companyLicenseNumber: [
          {
            required: false,
            message: '请输入营业执照/法人证书编号',
            trigger: 'change'
          },
          {
            validator: validate.validateCompanyLicenseNumber,
            trigger: 'change'
          }
        ],
        applyReason: [
          { required: true, message: '请输入申请理由', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    // 成功的回调
    onSuccess (res, file, fileList) {
      this.ruleForm.attachmentList = fileList
    },
    // 删除的回调
    handleRemove (index) {
      this.ruleForm.attachmentList.splice(index, 1)
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    doSubmit () {
      const obj = {
        ...this.ruleForm,
        attachmentList: this.ruleForm.attachmentList.map(
          (item) => {
            return item.response.data.aliOssId
          }
        )
      }
      this.loading = true
      this.$http
        .post('/openapi/v1/apl/cooperative-application/create', obj)
        .then(({ data: res }) => {
          this.loading = false
          if (res.code === 0) {
            this.$alert('信息提交成功，我们已经收到您的申请，会尽快给您答复，有疑问请邮件联系apl@supcon.com', '提示', {
              confirmButtonText: '关闭'
            }).then(() => {
              window.close()
              // 关不掉的页面刷新
              setTimeout(() => {
                window.location.reload()
              }, 300)
            }).catch(() => {
              window.close()
            })
          }
        })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.doSubmit()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.apl-bg {
  background: url(./images/bg.png) no-repeat;
  ::v-deep(.el-form-item) {
    margin-bottom: 8px;
  }
  ::v-deep(.is-error.el-form-item) {
    margin-bottom: 22px;
  }
  ::v-deep(.el-upload-list) {
    display: none;
  }
}

.apl-content {
  width: 730px;
  padding: 40px 60px 36px;
  margin: 0 auto;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(42, 84, 209, 0.12);
  .big-title {
    margin: 0;
    font-size: 24px;
    line-height: 33px;
    font-weight: bold;
    color: #333333;
    text-align: center;
  }
  .des {
    margin: 8px 0 20px;
    font-size: 14px;
    line-height: 19px;
    color: #666666;
    text-align: center;
  }
  .apl-title {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    color: #333333;
    padding: 12px 0 4px;
  }
}

.upload-btn {
  text-align: center;
  width: 132px;
  height: 40px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #2a54d1;
  font-size: 14px;
  color: #666666;
  &:hover {
    color: #2a54d1;
  }
  img {
    margin-right: 8px;
  }
}
.sub-btn {
  width: 100%;
  background: linear-gradient(275deg, #2a54d1 -1%, #5b85ff 100%);
  border: 0;
  margin-top: 24px;
  &:hover {
    opacity: 0.8;
  }
}
.more-tip {
  font-size: 14px;
  color: #666666;
  line-height: 19px;
  padding-top: 12px;
  text-align: center;
}
.list {
  .item {
    display: flex;
    align-items: center;
    margin-top: 12px;
    padding: 0 20px;
    line-height: 40px;
    border-radius: 8px;
    background: rgba(42, 84, 209, 0.15);
    &:first-child {
      margin-top: 0;
    }
  }
  .name {
    flex: 1;
    padding-left: 8px;
    font-size: 14px;
    font-weight: 700;
    color: #2a54d1;
  }
  .close {
    cursor: pointer;
  }
}
</style>
